// extracted by mini-css-extract-plugin
export default {"productThumbnail":"ProductList_productThumbnail__XcBM8"};